module.exports = __webpack_public_path__ + "4d64b0a556a91621f0d3da8b520cb99f.svg";